module.exports = __webpack_public_path__ + "assets/images/calendar_screen.jpg";